import React, { Component } from "react";
import "./header.scss";
import { timer } from "utils/constants";
import { storage } from "services/config/storage";
import { withRouter } from "react-router-dom";

import Timer from "../timer";
import { Close, MuteSpeaker, Speaker } from "static/assets/shoveberry/svgs.js";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: window?.innerWidth > 1024,
    };
  }
  render() {
    const { isMobile } = this.state;
    const timerMinutes = Math.floor(storage.get.timeRemaining() / 60);
    const timerSeconds = Math.floor(storage.get.timeRemaining() % 60);
    return (
      <header className="header">
        <div className="container">
          <div className="header-wrap">
            {isMobile ? (
              <div className="level">
                {this.props.level
                  ? `Level ${this.props.level} of ${this.props.totalLevels}`
                  : "Tutorial"}
              </div>
            ) : (
              <Close />
            )}
            <Timer
              updateTime={this.props.updateTime}
              minutes={timerMinutes}
              seconds={timerSeconds}
              onTimeFinish={this.props.onTimeFinish}
              level={this.props.level}
            />
            <div className="right-wrapper">
              <div
                className="volume-high"
                style={{ width: "100%" }}
                onClick={() =>
                  this.props.updateState("muteAudio", !this.props.muteAudio)
                }
              >
                {this.props.muteAudio ? <MuteSpeaker /> : <Speaker />}
              </div>
              {/* {isMobile?
                                <div className="close-icon" onClick={() => this.props.history.push("/")}>
                                    <Close/>
                                </div>
                                : null
                            } */}
              {/* <div className="reset" >
                <img src={require("assets/images/reset.svg")} alt="reset" />
              </div> */}
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default withRouter(Header);
